function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRipeDataLogoVerticalLightBk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3.3854167in",
    height: "6.5165663in",
    viewBox: "0 0 85.989585 165.52078",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-62.705315,-127.93133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g192"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect3719-2",
    width: 85.989586,
    height: 90.336304,
    x: 62.705315,
    y: 127.93133,
    style: {
      fill: "#f47e39",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    ry: 6.6145835
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.237247
    },
    id: "rect4526-8",
    width: 13.607142,
    height: 45.168156,
    x: 72.532692,
    y: 163.36661,
    ry: 0.17305341
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.212089
    },
    id: "rect4526-9-7",
    width: 13.607142,
    height: 36.096725,
    x: 90.234581,
    y: 172.43802,
    ry: 0.13829792
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.259528
    },
    id: "rect4526-2-7",
    width: 13.607142,
    height: 54.050594,
    x: 107.93647,
    y: 154.48415,
    ry: 0.20708483
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.287921
    },
    id: "rect4526-5-6",
    width: 13.607142,
    height: 66.523811,
    x: 125.63836,
    y: 142.01093,
    ry: 0.25487363
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "32.662px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#b3b3b3",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.67712
    },
    x: 84.171417,
    y: 231.29201,
    id: "text4565-1",
    transform: "scale(0.78817629,1.2687517)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan4563-4",
    x: 84.171417,
    y: 231.29201,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "32.662px",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#9a9a9a",
      fillOpacity: 1,
      strokeWidth: 0.67712
    }
  }, "DATA")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "41.7865px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#f47e39",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.217638
    },
    x: 65.173424,
    y: 251.73582,
    id: "text4569-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan4567-0",
    x: 65.173424,
    y: 251.73582,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "41.7865px",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#f47e39",
      fillOpacity: 1,
      strokeWidth: 0.217638
    }
  }, "ripe")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipeDataLogoVerticalLightBk);
export default __webpack_public_path__ + "static/media/RipeDataLogoVerticalLightBk.3a7d543f4be8e4b77e9983cd8e1fa920.svg";
export { ForwardRef as ReactComponent };